export default "__VITE_ASSET__DnE8T$$M__"